export function onlyNumbers(value: string, allowedChars = ""): string {
  const reg = new RegExp(`[^0-9${allowedChars}]`, "g");
  return value.trim().replace(reg, "");
}

export function isTelegramEnv(): boolean {
  const h = window.location.hash || "";
  return h.includes("tgWebAppPlatform=") || h.includes("tgWebAppData=");
}

export function hasTelegramIdParam(): boolean {
  return new URLSearchParams(window.location.search).has("telegram_id");
}
